// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_userProfileMainHeader__80yPN{
    background-color: #F4ECCE !important;
    border-radius: xl;
    overflow: hidden;
  }
  .Profile_memberShipList__NpqXE{
    background-color: #F5F5F5 !important;
    border-radius: xl;
    overflow: hidden;
    margin-top: 10px;
  }
  .Profile_userProfile__8oQmA{
      background-color: #EAA92A !important;
      width: w-1/8;
    }
  .Profile_cardMain__UgHa7{
    width: 98%;
    border-radius: 10px;
    overflow: hidden;
  }
  .Profile_cardListCheck__UQAcR{
    float: left;
    width: 10%;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  .Profile_cardListInfo__RyWe9{
    float: left;
    width: 80%;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
  }
  .Profile_cardListArro__SchIb{
    float: left;
    width: 10%;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  .Profile_merchantTradmark__3Jbzq{
    float: left;
    width: 100%;
    background-color: #F4ECCE;
    border-radius: 5px;
    height: 80px;
    margin-top: 10px;
  }
  
  .Profile_memberShipTitle__T-EcR{
    float: left;
    width: 100%;
    text-align: left;
    margin-top: 30px;
  }
  .Profile_memberShipH1__Fp3CI{
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    font-family: sans-serif;
  }
  .Profile_memberShipCard__rQRfF{
    width: 100%;
    float: left;
    margin-top: 10px;
    border-radius: 10px;
    background-color: #FFFFFF;
  }
  .Profile_faqTitle__B8D5y{
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    color: #267E94;
    padding-left: 20px;
  }
  .Profile_skipStyle__XB7-7{
    font-weight: bold;
    font-size: 24px;
  }
  .Profile_businessDay__YyS\\+0{
    font-weight: normal;
    font-size: 24px;
    text-align: center;
    padding: 15px;
    border: 1px solid;
    border-radius: 5px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Business/Profile.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,oCAAoC;IACpC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;MACI,oCAAoC;MACpC,YAAY;IACd;EACF;IACE,UAAU;IACV,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB","sourcesContent":[".userProfileMainHeader{\n    background-color: #F4ECCE !important;\n    border-radius: xl;\n    overflow: hidden;\n  }\n  .memberShipList{\n    background-color: #F5F5F5 !important;\n    border-radius: xl;\n    overflow: hidden;\n    margin-top: 10px;\n  }\n  .userProfile{\n      background-color: #EAA92A !important;\n      width: w-1/8;\n    }\n  .cardMain{\n    width: 98%;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  .cardListCheck{\n    float: left;\n    width: 10%;\n    text-align: center;\n    font-size: 20px;\n    font-weight: bold;\n  }\n  .cardListInfo{\n    float: left;\n    width: 80%;\n    text-align: left;\n    font-size: 20px;\n    font-weight: bold;\n  }\n  .cardListArro{\n    float: left;\n    width: 10%;\n    text-align: center;\n    font-size: 18px;\n    font-weight: bold;\n  }\n  .merchantTradmark{\n    float: left;\n    width: 100%;\n    background-color: #F4ECCE;\n    border-radius: 5px;\n    height: 80px;\n    margin-top: 10px;\n  }\n  \n  .memberShipTitle{\n    float: left;\n    width: 100%;\n    text-align: left;\n    margin-top: 30px;\n  }\n  .memberShipH1{\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 400;\n    font-family: sans-serif;\n  }\n  .memberShipCard{\n    width: 100%;\n    float: left;\n    margin-top: 10px;\n    border-radius: 10px;\n    background-color: #FFFFFF;\n  }\n  .faqTitle{\n    width: 100%;\n    font-size: 24px;\n    font-weight: 600;\n    color: #267E94;\n    padding-left: 20px;\n  }\n  .skipStyle{\n    font-weight: bold;\n    font-size: 24px;\n  }\n  .businessDay{\n    font-weight: normal;\n    font-size: 24px;\n    text-align: center;\n    padding: 15px;\n    border: 1px solid;\n    border-radius: 5px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userProfileMainHeader": `Profile_userProfileMainHeader__80yPN`,
	"memberShipList": `Profile_memberShipList__NpqXE`,
	"userProfile": `Profile_userProfile__8oQmA`,
	"cardMain": `Profile_cardMain__UgHa7`,
	"cardListCheck": `Profile_cardListCheck__UQAcR`,
	"cardListInfo": `Profile_cardListInfo__RyWe9`,
	"cardListArro": `Profile_cardListArro__SchIb`,
	"merchantTradmark": `Profile_merchantTradmark__3Jbzq`,
	"memberShipTitle": `Profile_memberShipTitle__T-EcR`,
	"memberShipH1": `Profile_memberShipH1__Fp3CI`,
	"memberShipCard": `Profile_memberShipCard__rQRfF`,
	"faqTitle": `Profile_faqTitle__B8D5y`,
	"skipStyle": `Profile_skipStyle__XB7-7`,
	"businessDay": `Profile_businessDay__YyS+0`
};
export default ___CSS_LOADER_EXPORT___;
